export default __webpack_public_path__ + "static/media/marlene-trainer.b31b9bad.svg";